import apiUrl from '../../../../utils/settings';

export const getBuyerRolesUrl = () => {
  return apiUrl + '/onboarding/buyer-roles';
};
export const GstUserGstDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-gstin-details';
};
export const GstUserPanDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-pan-details';
};
export const updateTokenUrl = () => {
  return apiUrl + '/auth/update-token';
};
export const addManufacturerRoleToExistingFirmUrl = () => {
  return apiUrl + '/manufacturer-role-map';
};
export const getLocationAndPincodeUrl = () => {
  return apiUrl + '/location-and-pincode/by-district';
};
